/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 캘린더 유형 선택 박스
 * 버전 : 1.0
 * 파일명 : RecruitSelectType.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정 : 2026-01-13, 강동형 : 축제 등록 UI 렌더링 조건추가
 * 수정 : 2026-02-04, 강동형 : 탭 변경시 초기화 로직 추가
 * 수정 : 2026-02-05, 강동형 : 축제 등록 기능 조건부 로직 추가
 *================================================================*/

import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import React, { SetStateAction, useEffect, useState } from 'react'
import { useRecruitStore } from 'src/stores/RecruitStore';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

const menuProps = {
    PaperProps: {
        sx: {
          maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:'46px',
    minWidth: '102px',
    textAlign:'center',
    justifyContent:'center',
    border: '1.5px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    // '& svg': {
    //   right: '30%',
    //   transform: 'translateX(50%)',
    //   position: 'absolute',
    //   pointerEvents: 'none',
    // },
}

const DropBoxSx = {
    // justifyContent: 'center',
    // textAlign: 'center',
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

type RecruitSelectTypeProps = {
  whichTab:'모집 일정' | '축제 정보'
  from? : '축제 등록' | undefined
  resetTrigger? : number
  setTypeProp? : React.Dispatch<SetStateAction<string>>
  typeProp? : string
}

const RecruitSelectType = ({whichTab, from, resetTrigger, setTypeProp, typeProp}:RecruitSelectTypeProps) => {
  const typeContent = whichTab === '모집 일정' ? ['모집유형','부사관','장교','준사관'] : from ? ['축제','박람회'] : ['축제유형','축제','박람회']
  const [type,setType] = useState(whichTab === '모집 일정' ? '모집유형' : typeProp ? typeProp : from ? '축제' : '축제유형');
  const setField = useRecruitStore((state)=>state.setField)
  const reset = useRecruitStore((state)=>state.reset)

  useEffect(()=>{
    reset('type')
  },[whichTab])

  useEffect(()=>{
    if(resetTrigger !== 0){
      setType(whichTab === '모집 일정' ? '모집유형' : '축제유형')
    }
  },[resetTrigger])

  const handleTypeChange = (e:SelectChangeEvent<string>)=>{
    if(from){
      setType(e.target.value)
      setTypeProp?.(e.target.value)
      return
    }
      setType(e.target.value)
      setField('type',e.target.value)
  }

  const customSx = {
    ...sx,
    ...(from === "축제 등록" && { textAlign: "left" }),
  };

  return (
      <Select
          value={type}
          onChange={handleTypeChange}
          renderValue={(selected) => `${selected}`}
          MenuProps={menuProps}
          sx={customSx}
          IconComponent={KeyboardArrowDown}
          >
          {typeContent.map((content) => (
              <MenuItem value={content.toString()} sx={DropBoxSx}>
                  {content}
              </MenuItem>
          ))}
      </Select>
  )
}

export default RecruitSelectType